document.addEventListener('DOMContentLoaded', function() {
   // Function to locate and modify the elements
   function modifyElements() {
     // Get all elements with the class "thumbnail-list_item--variant" and "aria-current=false"
     var thumbnailItems = document.querySelectorAll('.thumbnail-list_item--variant[aria-current=false]');
 
     // Add the "hidden" attribute to each matching element
     thumbnailItems.forEach(function(item) {
       item.setAttribute('hidden', '');
     });
 
     // Get all elements with the class "product-gallery__media" that do not have the class "is-selected"
     var galleryMediaItems = document.querySelectorAll('.product__media-item--variant:not(.is-selected)');
 
     // Add the "hidden" attribute to each matching element
     galleryMediaItems.forEach(function(item) {
       item.setAttribute('hidden', '');
     });
   }
 
   // Call the function on page load
   modifyElements();
 
   // Add an event listener for "variant:change" event
   document.addEventListener('variant:change', function() {
     // Call the function when the "variant:change" event occurs
     modifyElements();
   });
 });
 